import * as Sentry from '@sentry/browser';
import { ignoredBrowserErrorMessages } from './utils/browser-errors';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment =
    import.meta.env.VITE_DEPLOYMENT_ENV ||
    import.meta.env.MODE ||
    'development';
  const release = import.meta.env.VITE_GITHUB_RUN_NUMBER;

  if (!dsn) {
    console.log('⚠️  Sentry DSN not provided, skipping Sentry initialization');
    return;
  }

  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: 0,
    ignoreErrors: [...ignoredBrowserErrorMessages],
    beforeSend(event) {
      if (environment === 'test') {
        return null;
      }
      return event;
    },
    integrations: [
      Sentry.captureConsoleIntegration({
        levels: ['error'],
      }),
    ],
  });

  console.log('✅ Sentry initialized for frontend');
}

export function setSentryUser(user: {
  id: string;
  email?: string | null;
  name?: string | null;
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email || undefined,
    username: user.name || undefined,
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
